import { render } from "./ReestrEditForm.vue?vue&type=template&id=720974ad&scoped=true"
import script from "./ReestrEditForm.vue?vue&type=script&lang=js"
export * from "./ReestrEditForm.vue?vue&type=script&lang=js"

import "./ReestrEditForm.vue?vue&type=style&index=0&id=720974ad&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720974ad"]])

export default __exports__